import { useState, useEffect } from "react";
import HomeourProducts from "../Components/HomeourProducts";
import WhatsAppChat from "../Components/WhatsAppChat";
import { Link, useNavigate } from "react-router-dom";

import heroDesktop1 from "../images/home/homeimage1.avif";
import heroDesktop2 from "../images/home/homeimage2.avif";
import heroDesktop3 from "../images/home/homeimage3.avif";
import heroDesktop4 from "../images/home/homeimage4.avif";
import heroMobile1 from "../images/home/homeimage1-mobile.avif";
import heroMobile2 from "../images/home/homeimage2-mobile.avif";
import heroMobile3 from "../images/home/homeimage3-mobile.avif";
import heroMobile4 from "../images/home/homeimage4-mobile.avif";

import HomeourProcess from "../Components/HomeourProcess";
import HomeourExcellence from "../Components/HomeourExcellence";
import HomeglobalReach from "../Components/HomeglobalReach";
import ClientStories from "../Components/ClientStories";

export default function Home() {
  const [current, setCurrent] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

const slides = [
  {
    image: isMobile ? heroMobile1 : heroDesktop1,
    tag: "From Our Farms in India",
    title: "To Your Table Anywhere in the World",
    desc: "We export premium quality Fruits, Vegetables & Spices from India to global markets with trust, quality & reliability.",

    tagColor: "#73fac4",   // soft emerald
    titleColor: "#FFFFFF", // pure white
    descColor: "#F3F4F6",  // soft white
  },

  {
    image: isMobile ? heroMobile2 : heroDesktop2,
    tag: "Fresh & Organic Produce",
    title: "Naturally Grown, Carefully Packed",
    desc: "Our farm-to-export process ensures freshness, hygiene, and international quality standards in every shipment.",

    tagColor: "#73fac4",   // mint green
    titleColor: "#FFFFFF",
    descColor: "#F9FAFB",
  },

  {
    image: isMobile ? heroMobile3 : heroDesktop3,
    tag: "Harvested with Care in Indian Soil",
    title: "Delivering Nature’s Best Across Borders",
    desc: "We bring handpicked fruits, vegetables, and spices directly from trusted farms in India to global destinations with uncompromised freshness and purity.",

    tagColor: "#73fac4",   // teal mint
    titleColor: "#FFFFFF",
    descColor: "#F3F4F6",
  },

  {
    image: isMobile ? heroMobile4 : heroDesktop4,
    tag: "Grown Responsibly, Packed Thoughtfully",
    title: "Farm Fresh Quality You Can Trust",
    desc: "Every product goes through careful selection, hygienic processing, and export-grade packing to ensure superior taste and international standards.",

    tagColor: "#73fac4",   // elegant soft green
    titleColor: "#FFFFFF",
    descColor: "#F9FAFB",
  },
];

  const handlePrev = () => {
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  // Detect screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div>
      <div className="hero">
        {/* Background */}
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${slides[current].image})` }}
        ></div>

        {/* Overlay */}
        <div className="overlay"></div>

        {/* Content */}
        <div className="content">
          <p
            className="tag"
            style={{ color: slides[current].tagColor, fontSize: "16px" }}
          >
            {slides[current].tag}
          </p>

          <h1
            className="title"
            style={{ color: slides[current].titleColor, fontSize: "30px" }}
          >
            {slides[current].title}
          </h1>

          <p
            className="desc"
            style={{ color: slides[current].descColor, fontSize: "16px" }}
          >
            {slides[current].desc}
          </p>

          <div className="buttons">
            <button className="btn green" onClick={() => navigate("/products")}>
              🌾 Explore Our Products
            </button>
            <button className="btn orange" onClick={() => navigate("/contact")}>
              📞 Contact Us
            </button>
          </div>
          <div className="slider-buttons">
            <button className="nav-btn left" onClick={handleNext}>
              →
            </button>
            <button className="nav-btn right" onClick={handlePrev}>
              ←
            </button>
          </div>
        </div>

        {/* CSS */}
        <style>{`
        html, body, #root {
          height: 100%;
          width: 100%;
          margin: 0;
          padding: 0;
        }
        .slider-buttons {
          position: absolute;
          bottom: 60px;
          left: 65px;
          display: flex;
          gap: 5px; 
          z-index: 10;
        }
        .nav-btn {
          width: 50px;
          height: 50px;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          font-weight: bold;
          font-size: 22px;
          color: white;

          /* Gradient background */
          background: linear-gradient(135deg, #22c55e, #16a34a);

          display: flex;
          align-items: center;
          justify-content: center;

          /* Shadow for depth */
          box-shadow: 0 6px 18px rgba(0,0,0,0.3);

          transition: all 0.3s ease;
        }

        /* Hover Effect */
        .nav-btn:hover {
          background: linear-gradient(135deg, #16a34a, #15803d);
          transform: scale(1.15);
        }

        /* Position Left */
        .left {
          position: absolute;
          // left: 20px;
        }

        /* Position Right */
        .right {
          position: absolute;
          right: 5px;
        }

        * {
          box-sizing: border-box;
          font-family: 'Segoe UI', sans-serif;
        }

        .hero {
          position: relative;
          width: 100%;
          height: 100dvh;
          overflow: hidden;
          padding-top: 80px; /* adjust based on navbar height */
        }

        .hero-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          transition: 1s ease-in-out;
           animation: zoomFade 6s ease-in-out;
        }

        @keyframes zoomFade {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.08);
          }
        }

        @media (max-width: 768px) {
          .hero-bg {
            background-position: top center;
          }
        }

        .overlay {
          position: absolute;
          width: 100%;
          height: 100%;
          background:
            linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.18),
              rgba(0, 0, 0, 0.17)
            );
        }
       

        /* Animation */
        @keyframes slideDown {
          from {
            transform: translateY(-20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        /* ===== CONTENT SECTION ===== */
        
        .content {
          position: relative;
          z-index: 5;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;

          padding: 100px 40px 0 40px; /* top padding added */

         max-width: 520px;
          color: white;
        }

        /* small intro text */
        .tag {
          font-size: 16px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #22c55e; /* better green for premium look */
          text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
          margin-bottom: -10px;
          font-weight: 700;
        }

        /* main heading */
        .title {
          // font-size: 50px;
          font-weight: 800;
          color: orange;
          line-height: 1.2;
          margin-bottom: 18px;
          letter-spacing: -0.5px;
          text-shadow: 0 2px 8px rgba(0,0,0,0.25);
        }

        /* description */
        .desc {
          font-size: 16px;
          line-height: 1.6;
          font-weight: 600;
          color: rgba(255,255,255,0.85);
          text-shadow: 0 2px 1px rgba(126, 124, 124, 0.81);
          margin-bottom: 28px;
          max-width: 520px;
        }

        /* buttons container */
        .buttons {
          display: flex;
          gap: 15px;
        }


        /* buttons */
        .btn {
          padding: 15px 28px;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 15px;
          transition: all 0.3s ease;
        }

        /* primary */
        .green {
          
          background: linear-gradient(135deg, #22c55e, #16a34a);
          color: white;
          box-shadow: 0 10px 20px rgba(34,197,94,0.3);
        }

        .green:hover {
          transform: translateY(-2px);
        }

        /* secondary */
        .orange {
          background: rgba(255, 255, 255, 0.32);
          color: white;
          backdrop-filter: blur(8px);
          border: 1px solid rgba(255,255,255,0.2);
        }

        .orange:hover {
          background: rgba(255,255,255,0.25);
          transform: translateY(-2px);
        }
          @media (max-width: 768px) {
          .title {
            font-size: 30px;
            line-height: 1.3;
          }
            .buttons {
            flex-direction: column;
            align-items: flex-start; /* keeps them neat */
          }

          .btn {
            width: 80%;        /* 🔥 reduces width */
            max-width: 280px;  /* prevents it from becoming too large */
            text-align: center;
          }

          .desc {
            font-size: 14px;
          }

          .buttons {
            flex-direction: column;
          }

          .btn {
            width: 100%;
            text-align: center;
          }
        }
        

        /* ✅ MOBILE FIX (TEXT DOWN) */
        @media (max-width: 768px) {

          .content {
            position: absolute;
            bottom: 20px;   /* 🔥 THIS MOVES TEXT DOWN */
            left: 0;
            padding: 0 20px;
          }

          h1 {
            font-size: 26px;
          }

          .desc {
            font-size: 14px;
          }

          .buttons {
            flex-direction: column;
            // width:200px;
          }
        }
      `}</style>
      </div>
      <HomeourProducts />
      <HomeourProcess />
      <HomeourExcellence />
      <HomeglobalReach />
      <ClientStories />
      <WhatsAppChat />
    </div>
  );
}
